import { makeStyles } from "@material-ui/core/styles";

const styles = makeStyles(({ spacing }) => ({
  tooltip: {
    margin: spacing(0.5, 0, 0, 2),
  },
  tooltipText: {
    fontSize: 8,
    fontWeight: 400,
  },
}));

export default styles;
